import { makeStyles, Theme } from "@material-ui/core";

export const documentStyles = makeStyles((theme: Theme) => ({
  pdfContainer: {
    height: "65vh",
    marginTop: 20,
  },
}));
